"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.86,18.82c-.72-1.08-2.7-1.86-6.13-3.15A5,5,0,0,0,15,14.31v-1.5a4.27,4.27,0,0,0,1.5-3,2.32,2.32,0,0,0,.09-3,8.67,8.67,0,0,0,.9-4.41C17.15.76,14.69.13,12.69.13c-1.5,0-3.43.39-4,1.5a1.89,1.89,0,0,0-1.38.73c-.87,1.17-.27,3,.15,4.5a2.35,2.35,0,0,0,.07,3,4.26,4.26,0,0,0,1.5,3H9v1.5a5,5,0,0,0-1.72,1.36C3.84,17,1.86,17.8,1.14,18.88A11.22,11.22,0,0,0,0,23.67c0,.27,24,.27,24,0A11.19,11.19,0,0,0,22.86,18.82Z"
  }));
};

exports["default"] = _default;